<app-page-header [title]="pageTitle" [breadcrumbs]="breadcrumbs" [buttons]="buttons"></app-page-header>

<div class="container-fluid">
    <form [formGroup]="manufacturerForm">
        <!-- First Card - Default Price -->
        <mat-card>
            <mat-card-content>
                <div class="row">
                    <div class="col-12 col-md-6">
                        <div class="mb-3">
                            <mat-form-field class="w-100">
                                <mat-label>Manufacturer</mat-label>
                                <mat-select formControlName="manufacturer_id">
                                    <mat-option *ngFor="let manufacturer of manufacturers" [value]="manufacturer.id">
                                        {{ manufacturer.name }}
                                    </mat-option>
                                </mat-select>

                                <mat-error *ngIf="manufacturerForm.controls['manufacturer_id'].invalid">
                                    Manufacturer is required
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="col-12 col-md-6" *ngIf="!isDynamicallyPriced || actionType === 'add'">
                        <div class="mb-3">
                            <mat-form-field class="w-100">
                                <mat-label>Price effective from</mat-label>
                                <input matInput [matDatepicker]="picker" [min]="currentDate" formControlName="effective_from" placeholder="Choose a date" />

                                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                                <mat-datepicker #picker></mat-datepicker>
                            </mat-form-field>
                        </div>
                    </div>

                    <ng-container *ngIf="!isDynamicallyPriced || actionType === 'add'">
                        <div class="col-12 my-3 d-flex align-items-center">
                            <h3 class="d-inline-block mb-0">Price</h3>
                            <div class="d-inline-block ms-2"
                                matTooltip="This price is used as the base price when a pricing tier is not found.">
                                <mat-icon>info</mat-icon>
                            </div>
                        </div>

                        <div class="col-12">
                            <div class="row">
                                <div class="col-12 col-md-3">
                                    <div class="mb-3">
                                        <mat-form-field class="w-100">
                                            <mat-label>Operative Cost (£)</mat-label>
                                            <input matInput type="number" min="0" formControlName="operative_cost"  />

                                            <mat-error *ngIf="manufacturerForm.controls['operative_cost'].invalid">
                                                Operative Cost is required
                                            </mat-error>
                                        </mat-form-field>
                                    </div>
                                </div>

                                <div class="col-12 col-md-3">
                                    <div class="mb-3">
                                        <mat-form-field class="w-100">
                                            <mat-label>Sub Contractor Cost (£)</mat-label>
                                            <input matInput type="number" min="0" formControlName="subcontractor_cost" />

                                            <mat-error *ngIf="manufacturerForm.controls['subcontractor_cost'].invalid">
                                                Sub Contractor Cost is required
                                            </mat-error>
                                        </mat-form-field>
                                    </div>
                                </div>

                                <div class="col-12 col-md-3">
                                    <div class="mb-3">
                                        <mat-form-field class="w-100">
                                            <mat-label>Material Cost (£)</mat-label>
                                            <input matInput type="number" min="0" formControlName="material_cost" />

                                            <mat-error *ngIf="manufacturerForm.controls['material_cost'].invalid">
                                                Material Cost is required
                                            </mat-error>
                                        </mat-form-field>
                                    </div>
                                </div>

                                <div class="col-12 col-md-3 mb-2">
                                    <div class="mb-3">
                                        <mat-form-field class="w-100">
                                            <mat-label>Sell (£)</mat-label>
                                            <input matInput type="number" min="0" formControlName="sell_price" />

                                            <mat-error *ngIf="manufacturerForm.controls['sell_price'].invalid">
                                                Sell Price is required
                                            </mat-error>
                                        </mat-form-field>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ng-container>
                </div>
            </mat-card-content>
        </mat-card>

        <!-- Second Card - Pricing Tiers -->
        <ng-container *ngIf="isDynamicallyPriced && actionType === 'edit'">
            <mat-card class="mt-4">
                <mat-card-content>
                    <div class="d-flex align-items-center mb-3">
                        <h3 class="mb-0">Pricing Tiers</h3>
                        <div class="d-inline-block ms-2"
                            matTooltip="Pricing tiers are used when you want to change your pricing based on sizing, using this for Ablative Batt is an example of where this can be useful.">
                            <mat-icon>info</mat-icon>
                        </div>

                        <div class="ms-auto">
                            <button type="button" mat-stroked-button color="primary" class="mx-2" (click)="openAdditionalPriceModal()">
                                View Upcoming Price Changes
                            </button>

                            <button type="button" mat-stroked-button color="primary" class="mx-2" (click)="downloadTemplate();">
                                Download Price Template
                            </button>

                            <button type="button" mat-stroked-button color="primary" class="mx-2" (click)="uploadPrices();">
                                Import Tiers
                            </button>

                            <button type="button" mat-raised-button color="primary" (click)="addPriceTier()">
                                Add Tier
                            </button>
                        </div>
                    </div>

                    <div class="col-12 mb-5 table-responsive">
                        <table mat-table [dataSource]="dataSource" class="w-100">
                            <ng-container matColumnDef="tier">
                                <th mat-header-cell *matHeaderCellDef> Tier </th>
                                <td mat-cell *matCellDef="let row"> {{ row.tier }} </td>
                            </ng-container>

                            <ng-container matColumnDef="operative_cost">
                                <th mat-header-cell *matHeaderCellDef> Operative Cost (£) </th>
                                <td mat-cell *matCellDef="let row"> {{ row.operative_cost | currency:'GBP':'symbol':'1.2-2' }} </td>
                            </ng-container>

                            <ng-container matColumnDef="subcontractor_cost">
                                <th mat-header-cell *matHeaderCellDef> Sub Contractor Cost (£) </th>
                                <td mat-cell *matCellDef="let row"> {{ row.subcontractor_cost | currency:'GBP':'symbol':'1.2-2' }} </td>
                            </ng-container>

                            <ng-container matColumnDef="material_cost">
                                <th mat-header-cell *matHeaderCellDef> Material Cost (£) </th>
                                <td mat-cell *matCellDef="let row"> {{ row.material_cost | currency:'GBP':'symbol':'1.2-2' }} </td>
                            </ng-container>

                            <ng-container matColumnDef="sell_price">
                                <th mat-header-cell *matHeaderCellDef> Sell (£) </th>
                                <td mat-cell *matCellDef="let row"> {{ row.sell_price | currency:'GBP':'symbol':'1.2-2' }} </td>
                            </ng-container>

                            <ng-container matColumnDef="effective_from">
                                <th mat-header-cell *matHeaderCellDef> Effective From </th>
                                <td mat-cell *matCellDef="let row"> {{ row.effective_from | date:'dd/MM/yyyy' }}
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="effective_to">
                                <th mat-header-cell *matHeaderCellDef> Effective To </th>
                                <td mat-cell *matCellDef="let row"> {{ row.effective_to | date:'dd/MM/yyyy' }}
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="action">
                                <th mat-header-cell *matHeaderCellDef>Action</th>

                                <td mat-cell *matCellDef="let row; let i = index">
                                    <a mat-button class="hide-on-mobile" (click)="editPriceTier(row)">Edit</a>

                                    <button mat-icon-button (click)="$event.stopPropagation();" [matMenuTriggerFor]="menu">
                                        <mat-icon>more_vert</mat-icon>
                                    </button>
                                    <mat-menu #menu="matMenu">
                                        <button mat-menu-item class="hide-on-desktop" (click)="editPriceTier(row)">Edit</button>

                                        <ng-container *ngIf="row.tier > 0">
                                            <mat-divider></mat-divider>
                                            <a [swal]="{titleText: 'Are you sure you want to archive this pricing tier?', text: 'You can\'t undo this action.', icon: 'warning'}"
                                                (confirm)="deletePriceTier(row)" mat-menu-item>
                                                Archive
                                            </a>
                                        </ng-container>
                                    </mat-menu>
                                </td>
                            </ng-container>

                            <tr mat-header-row *matHeaderRowDef="displayColumns"></tr>
                            <tr mat-row *matRowDef="let row; columns: displayColumns;" [ngClass]="{'highlight-bg': row.edited}"></tr>

                            <!-- No data message -->
                            <tr class="mat-row" *matNoDataRow>
                                <td class="mat-cell text-center" [attr.colspan]="displayColumns.length">
                                    No active pricing tiers found
                                </td>
                            </tr>
                        </table>

                        <mat-paginator [length]="totalRows" [pageIndex]="currentPage" [pageSize]="pageSize"
                            [pageSizeOptions]="pageSizeOptions" (page)="pageChanged($event)">
                        </mat-paginator>
                    </div>
                </mat-card-content>
            </mat-card>
        </ng-container>
    </form>
</div>
